import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class LifelineNLADClaimService {
    AppUrl = '';
    constructor(private readonly _httpClient: HttpClient) {
        this.setAPIUrl();
    }

    setAPIUrl() {
        if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
            this.AppUrl = sessionStorage.getItem('BaseURL') || '';
        }
    }

    GetLifelineClaimProcessMasterPaged(filterModel: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/GetLifelineClaimProcessMasterPaged`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    LifelineClaimDataDelete(id: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/LifelineClaimDataDelete/` + id, { ClaimMasterId: id }, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineColumnMappedByCompanyListPaged(filterModel: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/GetLifelineColumnMappedByCompanyListPaged`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    MappedLifelineColumnDelete(providerId): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/MappedLifelineColumnDelete/` + providerId, { providerId: providerId }, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    LifelineClaimYearCountReports(tokenKey, filterModel: any): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/LifelineClaimYearCountReports`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    LifelineMonthlyClaimCountReports(tokenKey, filterModel: any): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/LifelineMonthlyClaimCountReports`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    LifelineClaimSummaryReports(tokenKey, filterModel: any): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/LifelineClaimSummaryReports`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineClaimProcessDetailsReports(tokenKey, filterModel: any): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/GetLifelineClaimProcessDetailsReports`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    ViewLifelineClaimProcessDetailsPaged(tokenKey, filterModel: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/ViewLifelineClaimProcessDetailsPaged`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }


    LifelineUploadExcelFile(formData: FormData): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/LifelineUploadExcelFile`, formData, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineColumnArray(model: any): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/GetLifelineColumnArray`, model, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    SaveLifelineColumnMapping(model: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/SaveLifelineColumnMapping`, model, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    LifelineClaimImport(formData: FormData): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/LifelineClaimImport`, formData, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineNLADFileFormat(): Observable<any> {
        this.setAPIUrl();
        return this._httpClient.get(this.AppUrl + `api/NLADClaim/GetLifelineNLADFileFormat`)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineNLADFileFormatFindByProviderId(providerId): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/GetLifelineNLADFileFormatFindByProviderId/` + providerId, { providerId: providerId }, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineColumnArrayFindByProvideId(providerId): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/GetLifelineColumnArrayFindByProvideId/` + providerId, { providerId: providerId }, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineClaimYears(tokenKey, provider: any): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/GetLifelineClaimYears`, provider, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineInrollClientCompanyV2(): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/V2/GetLifelineInrollClientCompany`, {}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineColumnMappedByCompanyListPagedV2(filterModel: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/V2/GetLifelineColumnMappedByCompanyListPaged`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineClaimProcessMasterPagedV2(filterModel: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json' }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/V2/GetLifelineClaimProcessMasterPaged`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetClaimLifelineState(tokenKey): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/V2/GetClaimLifelineState`, {}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    ViewLifelineClaimProcessDetailsPagedV2(tokenKey, filterModel: any): Observable<any> {
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/V2/ViewLifelineClaimProcessDetailsPaged`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

    GetLifelineClaimProcessDetailsReportsV2(tokenKey, filterModel: any): Observable<any> {
        this.setAPIUrl();
        const httpOptions = { headers: new HttpHeaders({ Accept: 'application/json', Token: tokenKey }) };
        return this._httpClient.post(this.AppUrl + `api/NLADClaim/V2/GetLifelineClaimProcessDetailsReports`, filterModel, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }

}
